/* globals debounce, escapeRegExp */
/* eslint-disable complexity, wrap-iife */
(function($) {
  'use strict';

  function getResponseValue(item) {
    var disp = item.disp,
      key = item.key;
    if (!disp && key) {
      return key;
    }
    if (disp && disp.listMetadata && disp.listMetadata.UnitCode && disp.listMetadata.UnitCode[0]) {
      return disp.listMetadata.UnitCode[0];
    }
    if (disp && disp.listMetadata && disp.listMetadata.Title && disp.listMetadata.Title[0]) {
      return disp.listMetadata.Title[0];
    }
    if (disp) {
      return disp;
    }
    return item;
  }

  function activateSearch($search) {
    var searchPartialBaseUrl = $search.attr('data-partial-url'),
      searchPartialResults = $search.attr('data-partial-results'),
      collection = $search.attr('data-partial-collection'),
      heading = $search.attr('data-partial-heading'),
      profile = $search.attr('data-partial-profile'),
      autoCompletionFormat = 'json++',
      $searchInput = $search.find('input[type="text"]'),
      searchInputName = $searchInput.attr('name'),
      $searchPredictiveList = $search.find('.course-search__autocomplete'),
      $searchWrapper = $search.closest('.course-search'),
      searchInputValue = '';

    $searchWrapper.focusout(function() {
      setTimeout(function() {
        var $focused = $searchWrapper.find(':focus');

        if (!$focused.length) {
          $searchPredictiveList.fadeOut(300);
        }
      }, 100); //delay to wait until other element recieved focus
    });

    $searchPredictiveList
      .on('focusin', 'a', function() {
        $searchInput.val($(this).text());
      })
      .on('keydown', 'a', function(e) {
        if (e.keyCode === 40) {
          //arrow down
          var $next = $(this)
            .parent('li')
            .next();

          if ($next.length) {
            $next.find('a').focus();
            e.preventDefault();
          }
        } else if (e.keyCode === 38) {
          //arrow up
          var $prev = $(this)
            .parent('li')
            .prev();

          if ($prev.length) {
            $prev.find('a').focus();
            e.preventDefault();
          }
        }
      })
      .on('click', 'a', function(e) {
        var url = e.currentTarget.href;
        if (url.charAt(url.length - 1) === '#') {
          e.preventDefault();
          $searchInput.val($(this).text());
          $searchInput.closest('form').submit();
          return false;
        }
        return true;
      });

    $searchInput
      .focusin(function() {
        $searchPredictiveList.fadeIn(300);
      })
      .keydown(function(e) {
        if (e.keyCode === 40) {
          //keydown
          if ($searchPredictiveList.find('a').length) {
            $searchPredictiveList.find('li:first-child a').focus();
          }
        }
      })
      .keyup(
        debounce(function() {
          var searchValue = $searchInput.val(),
            searchQuery = searchValue.toLowerCase(),
            searchPartialUrl =
              searchPartialBaseUrl +
              '?' +
              'partial_' +
              searchInputName +
              '=' +
              encodeURIComponent(searchValue) +
              '&show=' +
              searchPartialResults +
              '&collection=' +
              collection +
              '&profile=' +
              profile +
              '&fmt=' +
              autoCompletionFormat;

          if (searchInputValue !== searchValue) {
            searchInputValue = $.parseJSON(JSON.stringify(searchValue)); //cloning to break the reference

            if (searchQuery.length) {
              $.getJSON(searchPartialUrl, function(data) {
                $searchPredictiveList.empty();
                var searchQueryRegex = new RegExp(
                    '(' + escapeRegExp(searchQuery) + ')',
                    'gi'
                  ),
                  $searchPredictiveListHtml;
                if (data.length) {
                  $searchPredictiveListHtml = '<ul>\n';

                  $searchPredictiveListHtml += heading
                    ? '<li><div>' + heading + '</div></li>\n'
                    : '';

                  $.each(data, function(key, item) {
                    var searchPredictiveItem = getResponseValue(item);
                    var searchSuggestionUrl = item.disp.displayUrl
                        ? item.disp.displayUrl
                        : '#',
                      searchPredictiveItemHtml = searchPredictiveItem.replace(
                        searchQueryRegex,
                        '<strong>$1</strong>'
                      );
                    $searchPredictiveListHtml +=
                      '<li><a href="' +
                      searchSuggestionUrl +
                      '">' +
                      searchPredictiveItemHtml +
                      '</a></li>\n';
                  });

                  $searchPredictiveListHtml += '</ul>\n';

                  $searchPredictiveList.html($searchPredictiveListHtml);
                }
              });
            } else {
              $searchPredictiveList.empty();
            }
          }
        }, 250)
      );
  }

  $('.course-search form').each(function() {
    activateSearch($(this));
  });
})(jQuery);
